import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class AdminCypressAttribute extends CypressAttribute {
  static toolItemFn(key: string): string {
    return `AdminCypressAttribute:buttons:TOOL_ITEM_${key}`;
  }

  static views: Record<string, string> = {
    GIVE_FEEDBACK_MODAL_BODY: 'AdminCypressAttribute:views:GIVE_FEEDBACK_MODAL_BODY'
  };
}
